import { router } from "@inertiajs/react";
import { Eye } from "lucide-react";
import { Button } from "@/components/ui/Button";

export type Impersonating = { id: string; name: string; email: string };

// Full-width banner shown on every page while "View as" is active, so the
// impersonated context is impossible to miss. Exiting restores the real user.
export default function ImpersonationBanner({ impersonating }: { impersonating: Impersonating }) {
  return (
    <div className="flex items-center justify-center gap-3 bg-primary/10 border-b border-border px-4 py-1.5 flex-shrink-0">
      <Eye size={14} className="text-primary flex-shrink-0" strokeWidth={2} />
      <span className="text-[13px] text-foreground">
        Viewing as <span className="font-medium">{impersonating.name}</span>{" "}
        <span className="text-muted-foreground">({impersonating.email})</span>
      </span>
      <Button
        variant="outline"
        size="sm"
        className="h-6 px-2 text-xs"
        onClick={() => router.delete("/team/members/stop_impersonation")}
      >
        Exit
      </Button>
    </div>
  );
}
